<template>

    <swiper class="shop-item" :options="swiperOptions">
        <!--todo 禮包增加樣式giftPack-->
        <swiper-slide  class="coupon-item" v-for="(item, index) in list.slice(0,PreviewNum)" :key="index" @click.native.stop="onClick(item)"
                       :class="{'giftPack': item.ticketTypeId === ticketTypeGiftPackId}">
            <div class="cover coupon-cover">
                <el-image
                        :src="item.titleImage"
                        fit="cover"/>
            </div>
            <div class="title">
                <span class="coupon-type" :title="item.typeName">{{item.typeName.substring(0, 2)}}</span>
                {{item.name}}
            </div>
            <div class="brand">{{item.brandName}} {{item.storeName}}</div>
            <div class="left-count plus" v-if="item.residue >= 100 && (item.ticketTypeId === ticketTypeCouponId || item.ticketTypeId === ticketTypeGiftPackId)">99</div>
            <div class="left-count" v-else-if="item.ticketTypeId === ticketTypeCouponId|| item.ticketTypeId === ticketTypeGiftPackId">{{item.residue}}</div>
            <div v-else></div>
        </swiper-slide>

    </swiper>

</template>

<script>
    /*todo 輪播組件Swiper只支援vue3，要另外用外掛vue-awesome-swiper
       demo https://github.surmon.me/vue-awesome-swiper/
       swiper4-6功能中文網 https://www.swiper.com.cn/api/autoplay/19.html*/
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import * as constDefine from "@/store/constDefine";

    export default {
        name: "SliderTicket",
        props: [
            'dataToken',
            'list',
            'PreviewNum' //預覽時抓取的筆數
        ],
        components: {
            Swiper,
            SwiperSlide,
        },
        computed: {

        },
        data() {
            return {
                //輪播用
                swiperOptions: {
                    loop: false,
                    spaceBetween: 20,
                    slidesOffsetBefore : 20,
                    slidesPerView: 'auto',
                    touchMoveStopPropagation : true,//阻止touchmove冒泡事件
                },
                ticketTypeCouponId: constDefine.TicketType.Coupon.id,
                ticketTypeLoyaltyCardId: constDefine.TicketType.LoyaltyCard.id,
                ticketTypeCardId: constDefine.TicketType.Card.id,
                ticketTypeRewardPointId: constDefine.TicketType.RewardPoint.id,
                ticketTypeGiftPackId: constDefine.TicketType.GiftPack.id,
            }
        },
        mounted() {

        },
        methods: {
            onClick(item) {
                let objectType = 0
                let objectId = 0
                try {
                    let dataObject = this.$crypto.uriComponentToObject(this.dataToken);
                    objectType = dataObject.objectType || 0
                    objectId = dataObject.objectId || 0

                    if (objectType === constDefine.MerchantType.ShoppingArea) {
                        objectType = constDefine.MerchantType.ShoppingAreaActivity
                        objectId = item.shoppingAreaActivityId
                    }
                } catch(e) {
                    objectType = 0
                    objectId = 0
                }

                let obj = {
                    "id": item.id,
                    "ticketTypeId": item.ticketTypeId,
                    "objectType": objectType,
                    "objectId": objectId,
                }

                let encryptedString = this.$crypto.encryptObject(obj);
                this.$router.push({name: 'TicketDetail', query: {'p': encryptedString}});
            }
        }

    }
</script>

<style scoped lang="less">
    .swiper-slide:first-child{
        @media(min-width: 768px){
            margin-left: 20px;
        }
    }
    .coupon-item{
        width: 145px !important;
        @media (min-width: 1024px){
            width: 181px !important;
            cursor: pointer;
            &:hover{
                opacity: .7;
            }
        }
    }
</style>
